import { MapMarker, Video, Location, Mehilainen } from '@mehilainen/mds-customer/icons'
import React, { FC } from 'react'

import { LocationResult, LocationType } from '../../../__generated__/api'
import { isAllGeolocateLocation, isGeolocateLocation } from '../LocationSelect/utils'

import { SearchTreeItem } from './types'

type Props = {
  item: SearchTreeItem<LocationResult>
}

export const LocationIcon: FC<Props> = ({ item }) => {
  return isGeolocateLocation(item.item) || isAllGeolocateLocation(item.item) ? (
    <Location />
  ) : item.item?.type === LocationType.Clinic ? (
    <Mehilainen />
  ) : item.item?.type === LocationType.All ? (
    <Video />
  ) : (
    <MapMarker />
  )
}
